import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppConfig } from '@app/config/app.config';
import { AuthGuardService } from '@app/core/auth/auth-guard.service';
import { MainComponent } from '@app/certificates/main/component/main.component';
import { SigningComponent } from '@app/certificates/signing/component/signing.component';
import { DevicesPageComponent } from '@app/certificates/devices/devices-page/devices-page.component';
import { ManagePageComponent } from '@app/certificates/manage/manage-page/manage-page.component';
import { PacksComponent } from '@app/certificates/packs/packs.component';
import { ConsentsComponent } from '@app/certificates/consents/consents.component';
import { HistoryComponent } from '@app/certificates/history/history.component';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: '',
        redirectTo: AppConfig.routes.certificates.sign,
        pathMatch: 'full'
      },
      {
        path: AppConfig.routes.certificates.sign,
        component: SigningComponent,
        canActivate: [AuthGuardService],
        data: {
          title: AppConfig.routes.certificates.sign
      }
      },
      {
        path: AppConfig.routes.certificates.manage,
        component: ManagePageComponent,
        canActivate: [AuthGuardService],
        data: {
          title: AppConfig.routes.certificates.manage
        }
      },
      {
        path: AppConfig.routes.certificates.devices,
        component: DevicesPageComponent,
        canActivate: [AuthGuardService],
        data: {
          title: AppConfig.routes.certificates.devices
        }
      },
      {
        path: AppConfig.routes.certificates.packs,
        component: PacksComponent,
        canActivate: [AuthGuardService],
        data: {
          title: AppConfig.routes.certificates.packs
        }
      },
      {
        path: AppConfig.routes.certificates.history,
        component: HistoryComponent,
        canActivate: [AuthGuardService],
        data: {
          title: AppConfig.routes.certificates.history
        }
      },
      {
        path: AppConfig.routes.certificates.consents,
        component: ConsentsComponent,
        canActivate: [AuthGuardService],
        data: {
          title: AppConfig.routes.certificates.consents
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CertificatesRoutingModule { }
